import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    searchMeta: null,
    filters: [],
    tillClosureList: [],
    tillAttendantList: [],
    tillSummaryList: [],
    tillAttendantCashierList: [],
    lastQuery: null,
    outletId: null,
    since: null,
    until: null,
    typeDate: null,
};

const getters = {
    filters(state) {
        return state.filters;
    },
};

const mutations = {
    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },
    setTypeDateA(state, type) {
        state.typeDate = type;
    },

    setFilters(state, filters) {
        state.filters = filters;
    },

    setTillClosureList(state, data) {
        state.tillClosureList = data;
    },

    setTillSummaryList(state, data) {
        state.tillSummaryList = data;
    },

    setTillAttendantList(state, data) {
        state.tillAttendantList = data;
    },

    setTillAttendantCashierList(state, data) {
        state.tillAttendantCashierList = data;
    },

    setLastQuery(state, query) {
        state.lastQuery = query;
    },

    setOutletId(state, data) {
        state.outletId = data;
    },

    setSince(state, data) {
        state.since = data;
    },

    setUntil(state, data) {
        state.until = data;
    },
};

const actions = {
    getSearchMeta({ commit, dispatch }, till_columns = {}) {
        const route = Laroute.route('franchise.report.till.search.meta');

        startLoading(dispatch, 'get-tillmeta');

        return axios
            .get(route, { params: till_columns })
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-tillmeta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-tillmeta');
                throw err;
            });
    },

    getSearchMetaIfNecessary({ commit, dispatch }) {
        if (!state.searchMeta) {
            return dispatch('getSearchMeta');
        }

        return Promise.resolve(state.searchMeta);
    },

    getTillClosureListIfNecessary({ commit, dispatch, state }, params = {}) {
        if (
            params.outlet_id != state.outletId ||
            params.since != state.since ||
            params.until != state.until ||
            !state.tillClosureList.length ||
            state.lastQuery != params.query
        ) {
            commit('setOutletId', params.outlet_id);
            commit('setSince', params.since);
            commit('setUntil', params.until);

            return dispatch('getTillClosureList', params);
        }

        return Promise.resolve(state.tillClosureList);
    },

    getTillAttendantListIfNecessary({ commit, dispatch, state }, params = {}) {
        if (
            params.outlet_id != state.outletId ||
            params.since != state.since ||
            params.until != state.until ||
            !state.tillClosureList.length ||
            state.lastQuery != params.query
        ) {
            commit('setOutletId', params.outlet_id);
            commit('setSince', params.since);
            commit('setUntil', params.until);

            return dispatch('getTillAttendantList', params);
        }

        return Promise.resolve(state.tillAttendantList);
    },

    getTillClosureList({ commit, dispatch }, params) {
        const route = Laroute.route('franchise.report.till.closure');

        let options = {
            params: _.merge(
                {
                    limit: 100,
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-till-closure');

        return axios
            .get(route, options)
            .then(res => {
                let data = res.data;

                commit('setTillClosureList', data);
                commit('setLastQuery', options.params.query);
                endLoading(dispatch, 'fetch-till-closure');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-till-closure');
                throw err;
            });
    },

    getTillAttendantList({ commit, dispatch }, params) {
        const route = Laroute.route('franchise.report.till.attendant');

        let options = {
            params: _.merge(
                {
                    limit: 100,
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-till-attendant');

        return axios
            .get(route, options)
            .then(res => {
                let data = res.data;

                commit('setTillAttendantList', data);
                commit('setLastQuery', options.params.query);
                endLoading(dispatch, 'fetch-till-attendant');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-till-attendant');
                throw err;
            });
    },

    getTillSummaryListIfNecessary({ commit, dispatch, state }, params = {}) {
        if (
            params.outlet_id != state.outletId ||
            params.since != state.since ||
            params.until != state.until ||
            !state.tillSummaryList.length ||
            state.lastQuery != params.query
        ) {
            commit('setOutletId', params.outlet_id);
            commit('setSince', params.since);
            commit('setUntil', params.until);

            return dispatch('getTillSummaryList', params);
        }

        return Promise.resolve(state.tillSummaryList);
    },

    getTillSummaryList({ commit, dispatch }, params) {
        const route = Laroute.route('franchise.report.till.summary');

        let options = {
            params: _.merge(
                {
                    limit: 100,
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-till-summary');

        return axios
            .get(route, options)
            .then(res => {
                let data = res.data;

                commit('setTillSummaryList', data);
                commit('setLastQuery', options.params.query);
                endLoading(dispatch, 'fetch-till-summary');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-till-summary');
                throw err;
            });
    },

    getTillAttendantCashierListIfNecessary(
        { commit, dispatch, state },
        params = {},
    ) {
        if (
            params.outlet_id != state.outletId ||
            params.since != state.since ||
            params.until != state.until ||
            !state.tillSummaryList.length ||
            state.lastQuery != params.query
        ) {
            commit('setOutletId', params.outlet_id);
            commit('setSince', params.since);
            commit('setUntil', params.until);

            return dispatch('getTillAttendantCashierList', params);
        }

        return Promise.resolve(state.tillAttendantCashierList);
    },

    getTillAttendantCashierList({ commit, dispatch }, params) {
        const route = Laroute.route('franchise.report.till.attendant.cashier');

        let options = {
            params: _.merge(
                {
                    limit: 100,
                    query: null,
                },
                params,
            ),
        };

        startLoading(dispatch, 'fetch-staff');

        return axios
            .get(route, options)
            .then(res => {
                let data = res.data;

                commit('setTillAttendantCashierList', data);
                commit('setLastQuery', options.params.query);
                endLoading(dispatch, 'fetch-staff');

                return data;
            })
            .catch(err => {
                endLoading(dispatch, 'fetch-staff');
                throw err;
            });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
